let navigateFn;

export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

export const getNavigate = () => navigateFn;
